import { MdClose } from 'react-icons/md';
import Modal from 'react-responsive-modal';

function TaskDetailsWarning({ isOpen, onClose, onConfirm, type }) {

    const closeIcon = <MdClose className="text-3xl mt-1 text-white" />;

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            container={document.getElementById('root')}
            center
            closeIcon={closeIcon}
            focusTrapped={false}
            classNames={{
                overlay: 'customOverlay',
                modal: 'customModalTask',
            }}
        >
            <div className="">
                <h2 className="text-base font-semibold text-white">
                    {type === "reportDelete" ? "Delete report?" : type === "roomChange" ? "Change room?" : "Delete task?"}
                </h2>
                <div className="deletedPopup !right-20 z-50">
                    <div className="text-sm text-white py-5">{type === "reportDelete" ? "Are you sure you want to delete this report?" : type === "roomChange" ? "Are you sure you want to change room?" : "Are you sure you want to delete this task?"}</div>
                    <div className='flex gap-2 justify-center'>
                        <div className="px-5 py-1.5 text-white border border-white rounded-full text-sm" onClick={onClose} >Cancel</div>
                        {
                            type === "roomChange" ?
                                <div className="px-5 py-1.5 text-white bg-red-600 rounded-full text-sm" onClick={onConfirm} >
                                    Confirm
                                </div> :
                                <div className="px-5 py-1.5 text-white bg-red-500  rounded-full text-sm" onClick={onConfirm} >
                                    Delete
                                </div>
                        }
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default TaskDetailsWarning;